export class OETireSizeFitmentDtoResponse {
  frontFitment: OETireSizeFitment;
  rearFitment: OETireSizeFitment;
}

export class OETireSizeFitment {
  notFit: boolean;
  fitAggressive: boolean;
  selectedVehicleOETireNotFit: boolean;
  notFitCode: number;
  fitAggressiveCode: number;
  constructor() {
    this.notFit = false;
    this.fitAggressive = false;
    this.selectedVehicleOETireNotFit = false;
    this.notFitCode = 0;
  }
}
export class OETireSizeFitmentNote {
  front: string;
  rear: string;
}


